
import { IRestfulConfigMap } from "@core/data-access/restful";
import { envConfig } from "@env/env-config";

let AnonymousUserRestConfig: IRestfulConfigMap = {
    anonymousRestService: {
        appPath: envConfig.appPath("base"),
        isAuth: false,
        actions: {
            // 匿名用户登录
            login: {
                method: "get",
                path: "/anonymousUser/:anonymousUserId/token",
                testPath: "/anonymousUser/:anonymousUserId/token",
                paramDefaults: {
                    "anonymousUserId": "@anonymousUserId"
                }
            }
        }
    }
}


export { AnonymousUserRestConfig };